class ICorePopupModal {
    constructor(wrapElement, options = {}) {
        this.options = {
            closeOnBackdrop: true,
            closeOnEscape: true,
            ...options,
        };

        this.wrap = wrapElement;

        if (!this.wrap) {
            return;
        }

        this.modal = this.wrap.querySelector('.icore-eventsbyrsquare-popup-modal');
        this.closeButton = this.wrap.querySelector('.icore-eventsbyrsquare-popup-modal__close-btn');
        this.backdrop = this.wrap.querySelector('.icore-eventsbyrsquare-popup-modal__backdrop');

        this.setupEventListeners();
    }

    show() {
        if (this.modal && this.backdrop) {
            this.modal.classList.add('icore-eventsbyrsquare-popup--active');
            this.backdrop.classList.add('backdrop--isActive');
            document.body.classList.add('icore-eventsbyrsquare-popup--is-active');

            if (window.$iCore?.lenis) {
                window.$iCore.actions.destroyLenis();
            }
        }
    }

    hide() {
        if (this.modal && this.backdrop) {
            this.modal.classList.remove('icore-eventsbyrsquare-popup--active');
            this.backdrop.classList.remove('backdrop--isActive');
            document.body.classList.remove('icore-eventsbyrsquare-popup--is-active');

            if (!window.$iCore?.lenis) {
                window.$iCore?.actions?.initializeLenis();
            }
        }
    }

    setupEventListeners() {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', (evt) => {
                evt.preventDefault();
                this.hide();
            });
        }

        if (this.backdrop && this.options.closeOnBackdrop) {
            this.backdrop.addEventListener('click', () => {
                this.hide();
            });
        }

        if (this.options.closeOnEscape) {
            document.addEventListener('keydown', (evt) => {
                if (evt.key === 'Escape' && this.modal?.classList.contains('icore-eventsbyrsquare-popup--active')) {
                    this.hide();
                }
            });
        }
    }
}

window.$iCore = window.$iCore || {};
window.$iCore.actions = window.$iCore.actions || {};

window.$iCore.actions.openFeatureBannerModal = (element, evt) => {
    evt.preventDefault();

    const modalWrapId = element.getAttribute('data-modal-wrap');

    if (!modalWrapId) {
        return;
    }

    const wrap = document.getElementById(modalWrapId);

    if (wrap?._icorePopupModal) {
        wrap._icorePopupModal.show();
    }
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-icore-popup-modal]').forEach((wrap) => {
        wrap._icorePopupModal = new ICorePopupModal(wrap, {
            closeOnBackdrop: true,
            closeOnEscape: true,
        });
    });
});
